<template>
  <div class="modal-overlay">
    <div class="modal-content" @click.stop>
      <!-- Header do Modal -->
      <div class="modal-header">
        <div class="header-left">
          <div class="workspace-info">
            <div class="workspace-icon" :style="{ backgroundColor: workspace.corWorkspace }">
              <span>{{ getWorkspaceIcon(workspace.icone) }}</span>
            </div>
            <div>
              <h2 class="modal-title">{{ t('editWorkspaceScore.title', { name: workspace.nome }) }}</h2>
              <p class="modal-subtitle">{{ workspace.tipo }}</p>
            </div>
          </div>
        </div>
        <button @click="close" class="modal-close">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>
      
      <!-- Formulário -->
      <form @submit.prevent="updateScore" class="modal-form">
        <!-- Peso Base -->
        <div class="form-group">
          <label class="form-label">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
            </svg>
            {{ t('editWorkspaceScore.baseWeight') }} *
          </label>
          <div class="input-group">
            <input
              v-model.number="form.peso"
              type="number"
              step="0.1"
              min="-999.9"
              max="999.9"
              class="form-input"
              placeholder="0.0"
              required
            />
            <div class="input-help">
              <span>{{ t('editWorkspaceScore.baseWeightHelp') }}</span>
            </div>
          </div>
        </div>

        <!-- Bonificações -->
        <div class="bonus-section">
          <h3 class="section-title">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"></path>
            </svg>
            {{ t('editWorkspaceScore.bonifications') }}
          </h3>
          
          <div class="bonus-grid">
            <!-- Bônus por Complexidade -->
            <div class="form-group">
              <label class="form-label">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
                </svg>
                {{ t('editWorkspaceScore.complexity') }}
              </label>
              <input
                v-model.number="form.bonusComplexidade"
                type="number"
                step="0.1"
                min="-999.9"
                max="999.9"
                class="form-input"
                placeholder="0.0"
              />
            </div>

            <!-- Bônus por Cliente -->
            <div class="form-group">
              <label class="form-label">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
                </svg>
                {{ t('editWorkspaceScore.client') }}
              </label>
              <input
                v-model.number="form.bonusCliente"
                type="number"
                step="0.1"
                min="-999.9"
                max="999.9"
                class="form-input"
                placeholder="0.0"
              />
            </div>

            <!-- Bônus por Reaproveitamento -->
            <div class="form-group">
              <label class="form-label">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                </svg>
                {{ t('editWorkspaceScore.reuse') }}
              </label>
              <input
                v-model.number="form.bonusReaproveitamento"
                type="number"
                step="0.1"
                min="-999.9"
                max="999.9"
                class="form-input"
                placeholder="0.0"
              />
            </div>
          </div>
        </div>


        <!-- Preview dos Cálculos -->
        <div class="preview-section">
          <h3 class="section-title">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"></path>
            </svg>
            {{ t('editWorkspaceScore.previewTitle') }}
          </h3>
          
            <div class="preview-grid">
              <div class="preview-item">
                <span class="preview-label">{{ t('editWorkspaceScore.totalScore') }}</span>
                <span class="preview-value total">{{ formatScore(calculatedScore.scoreTotal) }}</span>
              </div>
              <div class="preview-item">
                <span class="preview-label">{{ t('editWorkspaceScore.scoreWithoutBonus') }}</span>
                <span class="preview-value">{{ formatScore(calculatedScore.scoreSemBonus) }}</span>
              </div>
              <div class="preview-item">
                <span class="preview-label">{{ t('editWorkspaceScore.percentGeneralGoalTotal') }}</span>
                <span class="preview-value percentage" :class="getPercentageClass(percentualMetaGeralTotal)">
                  {{ formatPercentage(percentualMetaGeralTotal) }}
                </span>
              </div>
              <div class="preview-item">
                <span class="preview-label">{{ t('editWorkspaceScore.percentGeneralGoalNoBonus') }}</span>
                <span class="preview-value percentage" :class="getPercentageClass(percentualMetaGeralSemBonus)">
                  {{ formatPercentage(percentualMetaGeralSemBonus) }}
                </span>
              </div>
            </div>

          <!-- Barra de Progresso -->
          <div class="progress-section">
            <div class="progress-bar">
              <div 
                class="progress-fill" 
                :style="{ 
                  width: `${Math.min(100, Math.max(0, percentualMetaGeralTotal))}%`,
                  backgroundColor: getProgressColor(percentualMetaGeralTotal)
                }"
              ></div>
            </div>
            <div class="progress-text">
              <span>{{ t('editWorkspaceScore.remainingToGeneralGoal', { value: formatScore(faltanteMetaGeral) }) }}</span>
            </div>
          </div>
        </div>
        
        <!-- Botões -->
        <div class="modal-actions">
          <button type="button" @click="close" class="btn-secondary">
            {{ t('editWorkspaceScore.cancel') }}
          </button>
          <button type="submit" class="btn-primary" :disabled="loading">
            <span v-if="loading" class="loading-spinner"></span>
            {{ loading ? t('editWorkspaceScore.saving') : t('editWorkspaceScore.saveChanges') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted, onBeforeUnmount, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import api from '@/services/api'
import Swal from 'sweetalert2'

export default {
  name: 'EditWorkspaceScoreModal',
  props: {
    workspace: {
      type: Object,
      required: true
    },
    metaGeralManual: {
      type: Number,
      default: 0
    }
  },
  emits: ['close', 'updated'],
  setup(props, { emit }) {
    const { t } = useI18n()
    const loading = ref(false)
    
    const form = reactive({
      peso: 0,
      bonusComplexidade: 0,
      bonusCliente: 0,
      bonusReaproveitamento: 0
    })
    
    // Computed para cálculos em tempo real
    const calculatedScore = computed(() => {
      const peso = form.peso || 0
      const bonusComplexidade = form.bonusComplexidade || 0
      const bonusCliente = form.bonusCliente || 0
      const bonusReaproveitamento = form.bonusReaproveitamento || 0
      
      const scoreTotal = peso + bonusComplexidade + bonusCliente + bonusReaproveitamento
      const scoreSemBonus = peso
      
      return {
        scoreTotal,
        scoreSemBonus
      }
    })
    
    // Computed para percentuais da meta geral
    const percentualMetaGeralTotal = computed(() => {
      if (props.metaGeralManual === 0) return 0
      return (calculatedScore.value.scoreTotal / props.metaGeralManual) * 100
    })
    
    const percentualMetaGeralSemBonus = computed(() => {
      if (props.metaGeralManual === 0) return 0
      return (calculatedScore.value.scoreSemBonus / props.metaGeralManual) * 100
    })
    
    const faltanteMetaGeral = computed(() => {
      return Math.max(0, props.metaGeralManual - calculatedScore.value.scoreTotal)
    })
    
    // Métodos
    const close = () => {
      emit('close')
    }

    const handleKeydown = (event) => {
      if (event.key === 'Escape') {
        close()
      }
    }

    onMounted(() => {
      window.addEventListener('keydown', handleKeydown)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('keydown', handleKeydown)
    })
    
    const updateScore = async () => {
      try {
        loading.value = true
        
        const scoreData = {
          workspaceId: props.workspace.id,
          peso: form.peso,
          bonusComplexidade: form.bonusComplexidade,
          bonusCliente: form.bonusCliente,
          bonusReaproveitamento: form.bonusReaproveitamento
        }
        
        const response = await api.put(`/workspace-scores/workspace/${props.workspace.id}`, scoreData)
        
        emit('updated', response.data)
        emit('close')
        
        await Swal.fire({
          icon: 'success',
          title: t('editWorkspaceScore.swal.successTitle'),
          text: t('editWorkspaceScore.swal.successText', { name: props.workspace.nome }),
          timer: 2000,
          showConfirmButton: false
        })
        
      } catch (error) {
        console.error('Erro ao atualizar score:', error)
        await Swal.fire({
          icon: 'error',
          title: t('editWorkspaceScore.swal.errorTitle'),
          text: error.response?.data?.message || t('editWorkspaceScore.swal.errorFallback'),
          confirmButtonText: t('editWorkspaceScore.swal.ok')
        })
      } finally {
        loading.value = false
      }
    }
    
    const loadWorkspaceScore = async () => {
      try {
        const response = await api.get(`/workspace-scores/workspace/${props.workspace.id}`)
        const score = response.data
        
        form.peso = parseFloat(score.peso || 0)
        form.bonusComplexidade = parseFloat(score.bonusComplexidade || 0)
        form.bonusCliente = parseFloat(score.bonusCliente || 0)
        form.bonusReaproveitamento = parseFloat(score.bonusReaproveitamento || 0)
        
      } catch (error) {
        if (error.response?.status !== 404) {
          console.error('Erro ao carregar score:', error)
        }
      }
    }
    
    // Utilitários
    const formatScore = (value) => {
      if (value === null || value === undefined) return '0.0'
      return parseFloat(value).toFixed(1)
    }
    
    const formatPercentage = (value) => {
      if (value === null || value === undefined) return '0.0%'
      return `${parseFloat(value).toFixed(1)}%`
    }
    
    const getWorkspaceIcon = (icone) => {
      const icons = {
        'mail': '📧',
        'briefcase': '💼',
        'users': '👥',
        'chart': '📊',
        'settings': '⚙️',
        'star': '⭐',
        'heart': '❤️',
        'lightning': '⚡'
      }
      return icons[icone] || '📁'
    }
    
    const getPercentageClass = (percentual) => {
      const value = parseFloat(percentual || 0)
      if (value >= 100) return 'success'
      if (value >= 75) return 'warning'
      return 'danger'
    }
    
    const getProgressColor = (percentual) => {
      const value = parseFloat(percentual || 0)
      if (value >= 100) return '#10b981'
      if (value >= 75) return '#f59e0b'
      return '#ef4444'
    }
    
    onMounted(() => {
      loadWorkspaceScore()
    })
    
    watch(() => props.workspace, (newWorkspace) => {
      if (newWorkspace) {
        loadWorkspaceScore()
      }
    }, { deep: true })
    
    return {
      t,
      loading,
      form,
      calculatedScore,
      percentualMetaGeralTotal,
      percentualMetaGeralSemBonus,
      faltanteMetaGeral,
      close,
      updateScore,
      formatScore,
      formatPercentage,
      getWorkspaceIcon,
      getPercentageClass,
      getProgressColor
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  @apply fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50;
}

.modal-content {
  @apply bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto;
  background-color: var(--bg-secondary);
  border: 1px solid var(--border-primary);
}

.modal-header {
  @apply flex justify-between items-center p-6 border-b border-gray-200;
  border-bottom: 1px solid var(--border-primary);
}

.header-left {
  flex: 1;
}

.workspace-info {
  display: flex;
  align-items: center;
  gap: 16px;
}

.workspace-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: white;
  font-weight: 600;
}

.modal-title {
  @apply text-xl font-semibold text-gray-900;
  color: var(--text-primary);
  margin: 0 0 4px 0;
}

.modal-subtitle {
  @apply text-sm text-gray-600;
  color: var(--text-muted);
  margin: 0;
  text-transform: uppercase;
  font-weight: 500;
}

.modal-close {
  @apply text-gray-400 hover:text-gray-600 transition-colors;
  color: var(--text-muted);
}

.modal-close:hover {
  color: var(--text-primary);
}

.modal-form {
  @apply p-6 space-y-6;
}

.form-group {
  @apply space-y-2;
}

.form-label {
  @apply block text-sm font-medium text-gray-700;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
}

.form-input {
  width: 100%;
  padding: 12px 16px;
  background-color: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: 8px;
  color: var(--text-primary);
  transition: all 0.2s ease;
  font-size: 14px;
}

.form-input::placeholder {
  color: var(--text-muted);
}

.form-input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(88, 101, 242, 0.1);
  transform: translateY(-1px);
}

.form-input:hover {
  border-color: var(--border-hover);
  background-color: var(--bg-hover);
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.input-help {
  font-size: 12px;
  color: var(--text-muted);
  font-style: italic;
}

/* Seções */
.bonus-section {
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  padding: 20px;
  background-color: var(--bg-primary);
}

.section-title {
  @apply text-lg font-semibold text-gray-900;
  color: var(--text-primary);
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 16px 0;
}

.bonus-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.preview-section {
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  padding: 20px;
  background-color: var(--bg-primary);
}

.preview-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 20px;
}

.preview-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.preview-label {
  font-size: 12px;
  color: var(--text-muted);
  margin-bottom: 4px;
  text-transform: uppercase;
  font-weight: 500;
}

.preview-value {
  font-size: 18px;
  font-weight: 700;
  color: var(--text-primary);
}

.preview-value.total {
  color: var(--primary);
}

.preview-value.percentage.success {
  color: var(--success);
}

.preview-value.percentage.warning {
  color: var(--warning);
}

.preview-value.percentage.danger {
  color: var(--danger);
}

/* Progress Section */
.progress-section {
  margin-top: 20px;
}

.progress-bar {
  width: 100%;
  height: 12px;
  background-color: var(--bg-secondary);
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 8px;
}

.progress-fill {
  height: 100%;
  transition: width 0.3s ease;
  border-radius: 6px;
}

.progress-text {
  font-size: 12px;
  color: var(--text-muted);
  text-align: center;
}

.modal-actions {
  @apply flex justify-end gap-3 pt-4 border-t border-gray-200;
  border-top: 1px solid var(--border-primary);
}

.btn-secondary {
  @apply px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  border: 1px solid var(--border-primary);
}

.btn-secondary:hover {
  background-color: var(--bg-hover);
  border-color: var(--border-hover);
}

.btn-primary {
  @apply px-4 py-2 bg-blue-600 text-white hover:bg-blue-700 rounded-md transition-colors flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed;
  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 16px rgba(88, 101, 242, 0.4);
}

.loading-spinner {
  @apply w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin;
}

/* Responsive */
@media (max-width: 768px) {
  .modal-content {
    @apply mx-2 max-h-[95vh];
  }
  
  .bonus-grid {
    grid-template-columns: 1fr;
  }
  
  .preview-grid {
    grid-template-columns: 1fr;
  }
  
  .workspace-info {
    flex-direction: column;
    text-align: center;
  }
}
</style>
